<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "AgencyForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        agency_group_id: null,
        agency_contacts: []
      },
      isBusy: false,
    };
  },
  computed: {
    options: function(){
      return {
        agency_group_id_options: this.$store.getters["agency_group/getAll"].selectOptions("id", "name")
      }
    }
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            agency_group_id: item.agency_group ? item.agency_group.id : null,
          };
          this.isBusy = false;
        });
    }
    this.$store.dispatch("agency_group/getAll");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Agency/AgencyForm.vue